module.exports = __webpack_public_path__ + "img/Newbie_Dagger_01_Classic.a72ed91b.png";